import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FdCreatePagePlaceholderService {

  constructor(private http: HttpClient) { }

  getPlaceholders(pageBuilderId) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/${pageBuilderId}/createPlaceholders`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getCustomHeaders(pageBuilderId) {
    return this.http.get(`/vd/formBuilder/fetch/customHeaders/${pageBuilderId}`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getBeneCustomHeaders(pageBuilderId: number) {
    return this.http.get(`/vd/formBuilder/pageForm/${pageBuilderId}/masterList`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  saveCustomHeaders(payload) {
    return this.http.post(`/vd/formBuilder/create/customHeaders`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  saveBeneficiaryCustomHeaders(pageFormId, payload) {
    return this.http.post(`/vd/formBuilder/pageForm/${pageFormId}/masterList/save`, payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200) {
            return response;
          } else {
            return null;
          }
        })
      );
  }

  getBeneficiaryPlaceholders() {
    //const groupId = 1;
    return this.http.get(`/vd/formBuilder/masterList/placeholders`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getFormsBuilderPermisionList() {
    return this.http.get(`/formsBuilder/standardPermissions`)
      .pipe(
        pluck('data'),
        map((data: Array<any>) => {
          return data;
        })
      );
  }

  saveFormsBuilderPermision(payload) {
    return this.http.post(`/standardPermission/save`, payload)
      .pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status === 200) {
            return response;
          } else {
            return null;
          }
        })
      );
  }

}

